module.exports = __webpack_public_path__ + "static/img/icon_banner_logo.843a10b.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_banner_logo.png
// module id = yDCG
// module chunks = 1